import React from 'react';
import 'aframe';

const Glow = ({ darkMode, opacity = '0.2', size = 1, ...rest }) => {
  return (
    <a-image
      src={`#hotspot__glow${darkMode ? '' : '-dark'}`}
      material="transparent: true; depthWrite: false;"
      width={size}
      height={size}
      scale="1.6 1.6 1.6"
      opacity={opacity}
      position="0 0 -0.01"
      {...rest}
    />
  );
};

export default Glow;
